/* eslint-disable */
import React, { useState, useEffect, useRef, useMemo } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useSelector } from "react-redux";
import Highcharts from "highcharts";
import { Dropdown } from "react-bootstrap";
import moment from "moment";
import {
  CONSTANTS,
  DATE_FORMATS,
  GRAPH_TYPES,
  VERTICALS,
  REPORT_TYPES,
  LANGUAGE_CODES,
  GRAPH_TYPE_OPTIONS,
  HTTP_CODES,
  WORD_CLOUD_TYPE,
  SOCIAL_SOURCES,
  REPORT_WISE_SOCIAL_ICONS,
  VERTICAL_NAMES,
  LOGO,
  HOTSTAR_ID,
  GRAPH_DATATYPE,
  REPORT_CATEGORIES,
} from "../../../constants/app-constant";
import Loader from "../../Shared/Loader";
import { httpDelete, httpGet, httpPost } from "../../../utility/requestHelper";
import {
  envConfig,
  unifiedEnvConfig,
  qualitativeEnvConfig,
} from "../../../constants/api-endpoint";
import {
  groupBy,
  formatDate,
  getTrendGraphDateFormat,
  removeSpace,
  getSocialApiDateFormat,
  getConceptUserId,
} from "../../../utility/common-methods";
import { DownloadBlueIcon, MoreIcon } from "../../Icons/icons.component";
import { onlyUnique } from "../../../utility/arrayUtils";
import "./charts.sass";
import {
  formatedDataByJournalist,
  formatJournalistSentimentData,
  formatDataByRanking,
  formatDataByCity,
  formatDataByLanguage,
  formatThematicAnalysisEntity,
  formatThematicAnalysisTag,
  formatSentimentTableData,
  formatSpokesPersonData,
} from "../../Dashboard/data_formatter";
import {
  getLineGraphFormat,
  getRandomUniqueColor,
} from "../../Dashboard/data_formatter/format-utils";
import {
  newFormatSOVData,
  // formatStoryParticipationData,
} from "../../Dashboard/data_formatter/new-format-data-by-sov";

import { newFormatDataBySentiment } from "../../Dashboard/data_formatter/new-format-data-by-sentiment";
import { newFormatDataBySpokesperson } from "../../Dashboard/data_formatter/new-format-data-by-spokesperson";

import {
  getPublicationsFromResponse,
  newFormatPublicationData,
  getKeywordsFromResponse,
} from "../../Dashboard/data_formatter/new-format-data-by-publication";
import {
  newFormatDataByJournalist,
  getJournalistFromResponse,
} from "../../Dashboard/data_formatter/new-format-data-by-journalist";
import {
  newFormatDataByKeyword,
  getKeywordFromResponse,
} from "../../Dashboard/data_formatter/new-format-data-keyword";
import {
  newFormatThematicData,
  getThemesFromResponse,
} from "../../Dashboard/data_formatter/new-format-data-thematic-analysis";
import {
  newFormatGeolocationData,
  getZonesFromResponse,
  getEntitiesFromResponse,
} from "../../Dashboard/data_formatter/new-format-data-geolocation";
import * as KEYWORD_DATA_FORMATTER from "../../Dashboard/data_formatter/new-format-data-keyword";
import { formatDataByPublication } from "../../Dashboard/data_formatter/fomat-data-by-publication";
import WidgetInlineFilters from "../Filters/NewWidgetInlineFilters";
import EmbededFeedsList from "./EmbededFeedsList";
import VerticalTag from "../../Shared/VerticalTag";
import WidgetSwitch from "./WidgetSwitch";
import WidgetPagination from "./WidgetPagination";
import { AddWidget } from "../../Dashboard/AddWidget";
import {
  DATA_TYPES,
  SOCIAL_SOURCES_OPTIONS,
  TONALITY_FILTER,
  WIDGET_TYPES,
} from "../../../constants/static-filter";
import { ConfirmModal } from "../../Shared/Modal";
import {
  formatDataByTonalitySocial,
  formatSovRankingSocial,
  formatCitySpecificData,
  formatSocialWordCloudData,
  formatDataByPlatform,
  formatReachData,
  formatCitySpecificDataForLine,
} from "./social-data-formatter";
import {
  formatTagAnalysisData,
  formatTagAnalysisDataByEntity,
} from "./social-data-formatter";
import SocialIcon from "../SocialIcon";
import { CustomBSDropdown } from "../../Shared";
import { useCallback } from "react";
import {
  publicationPrintGenreFilterList as publicationGenrePrintInlineFilterList,
  publicationOnlineGenreFilterList as publicationGenreOnlineInlineFilterList,
} from "./AnalysisGroup/filter-constant";
import { getCorrectParamDetails } from "./utils/requestUrlHelper";
import { getCorrectChartTitle } from "./utils/chartTitleHelper";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/wordcloud")(Highcharts);

const biuLogo = `https://${window.location.host}/static/media/conceptbiu-logo.2b6a4886.png`;
const {
  REPORTS: { TYPES },
  PRINT_ONLINE_COUNT_KEYS,
} = CONSTANTS;

const {
  PIE,
  AREA,
  LINE,
  TABLE,
  WORD_CLOUD,
  GENDER,
  CHOROPLETH,
  DOUGHNUT,
  BAR_VERTICAL,
  BAR_STACKED,
  BAR_STACKED_EQUAL_HEIGHT,
} = GRAPH_TYPES;

const {
  JournalistNOATrend,
  JournalistAnalysisPrint,
  EditionWiseNOATrend,
  CityWiseNOATrend,
  CityWiseNOARanking,
  MediaWiseNOARanking,
  JournalistSentiment,
} = REPORT_TYPES;

const { V_ONLINE, V_PRINT, V_BLOG, V_FORUM, V_SOCIAL, V_PRINT_AND_ONLINE } =
  VERTICALS;

export const Widget = ({
  widget,
  isDashboardWidget,
  isAnalysisReport,
  isEmbededWidget,
  setEmbededFeedsParams,
  setEmbededRouteParams,
  handleTodayFeedWidgeStatus,
  setWidgetCreationStatus,
  fetchWidgets,
  selectedDataType,
  filteredWidgets,
  setFilteredWidgets,
  widgets,
  setWidgets,
  enableDownloadFn,
  preSelectedWCType,
  countryWiseFeeds,
  renderAnalysisWidget,
  contributedWidgetFilter: {
    preSelectedJournalist,
    preSelectedEdition,
    preSelectedPublication,
    preSelectedInlineInfluencerEntity,
    preSelectedInlineWCEntity,
  },
  twitterFeeds,
  topicId,
  startRange,
  endRange,
  selectedFilter,
  tonality = false,
  tabData,
  widgetApiInProgress,
  setGraphRefList,
  selectedEmbededGraphType,
  embededEnabled,
}) => {
  //console.log("widget", widget.selectedVerticalMain);
  const {
    id,
    from_date,
    to_date,
    graph_type,
    report_type,
    type, //vertical
    client_id,
    user_id,
    topic_ids,
    channel_type,
    selectedMainPublication,
    publisher_type,
    selectedMainSentiment,
    language,
    selectedMainEdition,
    selectedMainPressRelease,
    selectedMainCountry,
    value_type,
    chartType,
  } = widget || {};
  const [graphApiResponse, setGraphApiResponse] = useState({});
  const [rawDataApiResponse, setRawDataApiResponse] = useState(undefined);
  const [newApiRequest, setNewApiRequest] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedInlinePublication, setSelectedInlinePublication] = useState(
    preSelectedPublication || null
  );
  const [selectedInlineJournalist, setSelectedInlineJournalist] = useState(
    preSelectedJournalist || null
  );
  const [selectedEdition, setSelectedEdition] = useState(
    preSelectedEdition || null
  );
  const [dataByReportType, setDataByReportType] = useState([]);
  const [worldMapData, setWorldMapData] = useState([]);
  const [selectedInlineEntity, setSelectedInlineEntity] = useState("");
  const [feedsParams, setFeedsParams] = useState({});
  const [showFeedsList, setShowFeedsList] = useState(false);
  const [showPercentage, setShowPercentage] = useState(false);
  const [showWidgetConfig, setShowWidgetConfig] = useState(false);
  const [editWidgetData, setEditWidgetData] = useState({});
  const [inlineGraphTypeOptions, setInlineGraphOptions] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedInlineGraphType, setSelectedInlineGraphType] = useState(
    widget.graph_type
  );
  const [showError, setShowError] = useState(false);
  const [useDateRange, setUseDateRange] = useState(false);
  const [entityListByType, setEntityListByType] = useState([]);
  const [selectedInlineWCType, setSelectedInlineWCType] = useState(
    preSelectedWCType || WORD_CLOUD_TYPE[2]
  );
  const [selectedInlinePlatform, setSelectedInlinePlatform] = useState(null);
  const [selectedInlineSentiment, setSelectedInlineSentiment] = useState({
    value: "Positive",
    label: "Select Sentiment",
  });

  const [spokespersonList, setSpokesPersonList] = useState([]);
  const [sentimentList, setSentimentList] = useState([]);

  const [selectedInlineSpokesperson, setSelectedInlineSpokesperson] = useState({
    value: "",
    label: "Select Spokesperson",
  });

  const [selectedInlinePublicationGenre, setSelectedInlinePublicationGenre] =
    useState(() =>
      type === V_PRINT
        ? publicationGenrePrintInlineFilterList[0]
        : publicationGenreOnlineInlineFilterList[0]
    );

  const [selectedInlineWCEntity, setSelectedInlineWCEntity] = useState(
    preSelectedInlineWCEntity || null
  );
  const [selectedInlineInfluencerEntity, setSelectedInlineInfluencerEntity] =
    useState(preSelectedInlineInfluencerEntity || null);
  const [selectedInlineZone, setSelectedInlineZone] = useState({
    value: "North",
    label: "Select Zone",
  });
  const [graphRef, setGraphRef] = useState("");
  const [twitterBreakDown, setTwitterBreakDown] = useState({});
  const [twitterBreakDownPie, setTwitterBreakDownPie] = useState([]);
  const [twitterBreakDownLine, setTwitterBreakDownLine] = useState([]);
  const [twitterMetricsData, setTwitterMetricsData] = useState([]);
  const [keyMetrics, setKeyMetrics] = useState([]);
  const [isSameDateReport, setIsSameDateReport] = useState(false);
  const [countType, setCountType] = useState("");
  const chartContainer = React.createRef();
  const initRef = useRef(false);
  const [publicationList, setPublications] = useState([]);
  const [journaList, setJournalist] = useState([]);
  const [keywordList, setKeywordList] = useState([]);

  //show options variables
  const [newSelectedFilter, setNewSelectedFilter] = useState(selectedFilter);
  const [showPublication, setShowPublication] = useState(false);
  const [showEdition, setShowEdition] = useState(false);
  const [showKeyword, setShowKeyword] = useState(false);
  const [showJournlist, setShowJournlist] = useState(false);
  const [showSentiment, setShowSentiment] = useState(false);

  const [selectedPublicationId, setSelectedPublicationId] = useState(undefined);
  const [selectedTonality, setSelectedTonality] = useState(undefined);
  const [selectedEditions, setSelectedEditions] = useState(undefined);
  const [selectedJournlist, setSelectedJournlist] = useState(undefined);
  const [selectedKeyword, setSelectedKeyword] = useState(undefined);

  const [selectedInlineGenre, setSelectedInlineGenre] = useState();

  //for dynamic inline filters
  const [useInlineDynamicFilter, setUseInlineDynamicFilter] = useState(false);
  const [selectedInlineDynamicFilter, setSelectedInlineDynamicFilter] =
    useState({ value: "Filter", label: "Select Filter" });
  const [dynamicFilterList, setDynamicFilterList] = useState([]);
  const [selectedInlineDynamicFilterTwo, setSelectedInlineDynamicFilterTwo] =
    useState({ value: "Filter", label: "Select Filter" });
  const [dynamicFilterListTwo, setDynamicFilterListTwo] = useState([]);

  const [showPagination, setShowPagination] = useState(false);
  const [datasetIndex, setDatasetIndex] = useState(0);
  const [datasetLength, setDatasetLength] = useState(0);

  const [reportType, setReportType] = useState(
    TYPES.filter((t) => t.id === report_type)[0]
  );
  const [dynamicEntityList, setDynamicEntityList] = useState([]);
  const [currentParams, setCurrentParams] = useState({});
  const [routeParams, setRouteParams] = useState({});
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  const editionList =
    useSelector(
      (state) => state.filterReducer && state.filterReducer.editionList
    ) || [];
  const entityState =
    useSelector((state) => state.entityAndKeyWordsReducer) || {};

  const {
    selectedEntity,
    entityDetails: { entityList },
    socialEntityList,
  } = entityState;

  const clientId = selectedClient && selectedClient.id;

  const hasClientAndEntity = clientId;
  const { DELETED } = HTTP_CODES;
  const isLineGraph = selectedInlineGraphType === LINE;
  const isSocial = type == V_SOCIAL;
  const isBlogAndForum = type == V_BLOG || type == V_FORUM;
  const isPrintAndOnline =
    type == V_PRINT || type == V_ONLINE || type == V_PRINT_AND_ONLINE;
  const dateHash = `${getTrendGraphDateFormat(
    from_date,
    null,
    "Do MMMM YYYY"
  )} to ${getTrendGraphDateFormat(to_date, null, "Do MMMM YYYY")}`;
  const identifier = removeSpace(`${report_type}-${type}-${user_id}`);

  useEffect(() => {
    //update report type state when changes from parent component
    //widget is a memoized value in analysiswidget component
    widget.report_type &&
      setReportType(TYPES.filter((t) => t.id === widget.report_type)[0]);
  }, [widget.report_type]);

  useEffect(() => {
    entityList &&
      entityList[0] &&
      setSelectedInlineEntity({
        label: entityList[0].entity_display_name,
        value: entityList[0].entity_name,
      });
  }, [entityList]);

  useEffect(() => {
    let opts = GRAPH_TYPE_OPTIONS.filter(
      (opt) =>
        reportType && reportType.excludeGraphType.indexOf(opt.value) === -1
    );
    const listWithTable = opts.filter((elm) => elm.value == TABLE);
    if (!listWithTable || (!listWithTable.length && !twitterFeeds)) {
      opts = [
        ...opts,
        // {
        //   value: TABLE,
        //   label: "Table",
        // },
      ];
    }
    const graphVals = opts.map((grph) => grph.value);
    //widget.graph_type is static. to update selected graph dynamically we perform these checks
    // if (graphVals.indexOf(BAR_VERTICAL) !== -1) {
    //   setSelectedInlineGraphType(BAR_VERTICAL);
    // }
    // else 
    if (
      graphVals.indexOf(widget.graph_type) === -1 &&
      graphVals.indexOf(selectedInlineGraphType) === -1
    ) {
      //widget graph type and selected graph type not in list
      //update list with first option
      if (type === V_PRINT) setSelectedInlineGraphType(graphVals[0]);
      else if (type === V_ONLINE && graphVals.length >= 2)
        setSelectedInlineGraphType(graphVals[1]);
      else {
        setSelectedInlineGraphType(graphVals[0]);
      }
    } else if (graphVals.indexOf(selectedInlineGraphType) === -1) {
      //if widget.graph_type exists in the list
      setSelectedInlineGraphType(widget.graph_type);
    } else {
      //selected graph already in the list
      setSelectedInlineGraphType((prev) => prev);
    }
    setInlineGraphOptions(opts);
    return;
  }, [isEmbededWidget, reportType]);

  useEffect(() => {
    const chartHeight = isEmbededWidget ? 400 : 283;
    Highcharts.setOptions({
      chart: {
        height: chartHeight,
      },
      credits: {
        enabled: false,
      },
      series: {
        symbol: "circle",
      },
      yAxis: {
        tickAmount: 10,
        allowDecimals: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          groupPadding: "0.1",
        },
        series: {
          lineWidth: 1,
          marker: {
            radius: 3,
          },
          dataLabels: {
            formatter: function () {
              if (this.y > 0) return this.y;
            },
            allowOverlap: false,
            shadow: false,
            style: {
              fontWeight: "normal",
              fontSize: "10px",
              textShadow: false,
              textOutline: "none",
            },
          },
        },
      },
      legend: {
        layout: "horizontal",
        y: -10,
        align: "center",
        verticalAlign: "top",
        floating: false,
        alignColumns: false,
        margin: 0,
        itemDistance: 10,
        itemMarginBottom: 5,
        itemMarginTop: 0,
        itemStyle: {
          fontSize: "12px",
          fontWeight: "normal",
          color: "#666",
        },
        symbolHeight: 11,
        symbolWidth: 11,
        symbolRadius: 0,
        maxHeight: 65,
      },
      colors: [
        "#E96F6F",
        "#FCC023",
        "#D63548",
        "#0979E4",
        "#AF8BAF",
        "#ADB842",
        "#9D402B",
        "#034249",
        "#4B83BB",
        "#D974A2",
        "#FF6362",
        "#900B3F",
        "#F2A364",
        "#A2C4C6",
        "#C39D4C",
        "#A1D981",
        "#FFA299",
        "#FFA299",
      ],
      exporting: {
        sourceWidth: 1500,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
          title: {
            y: 100,
          },
          chart: {
            height: 600,
            width: 600,
            marginTop: 180,
            events: {
              load: function () {
                var renderer = this.renderer;
                renderer
                  .text(
                    `${getTimelineText()}`,
                    getTimelineTextPosition(getTimelineText()),
                    80
                  )
                  .add();
                renderer
                  .text(
                    `${getInlineFilterText()} `,
                    getTimelineTextPosition(getInlineFilterText()),
                    95
                  )
                  .add();
                renderer
                  .image(LOGO.biuLogoBase, 725, 10, 50, 50)
                  .attr({
                    align: "center",
                  })
                  .add();
              },
            },
          },
        },
      },
    });

    setTimeout(() => {
      setUseDateRange(true);
    }, 3000);
  }, [
    dateHash,
    feedsParams,
    selectedInlineJournalist,
    selectedInlineGraphType,
    selectedInlinePlatform,
    selectedInlinePublication,
    selectedInlineSentiment,
    selectedInlineEntity,
    selectedInlineSpokesperson,
  ]);

  useEffect(() => {
    if (
      selectedInlineGraphType == BAR_VERTICAL ||
      selectedInlineGraphType == BAR_STACKED ||
      selectedInlineGraphType == BAR_STACKED_EQUAL_HEIGHT
    ) {
      const graphRes =
        !graphApiResponse ||
        !graphApiResponse.datasets ||
        !graphApiResponse.datasets.length ||
        !graphApiResponse.labels ||
        !graphApiResponse.labels.length;
      setShowError(graphRes);
    } else if (selectedInlineGraphType === PIE) {
      const graphRes =
        !graphApiResponse ||
        !graphApiResponse.hcPieChartData ||
        !graphApiResponse.hcPieChartData.length;
      setShowError(graphRes);
    }
  }, [graphApiResponse]);

  // useEffect(() => {
  //   try {
  //     if (!rawDataApiResponse) {
  //       console.log("Fetching new data");
  //       setShowError(false);
  //       fetchGraph();
  //     } else {

  //       drawGraph(rawDataApiResponse);
  //     }
  //   } catch (e) {
  //     console.log("Error in graph", e);
  //   }
  // }, [
  //   //moved dateHash to clear rawDataApi state below in a useeffect
  //   //for new api call rawDataApi should be undefined
  //   //rawDataApi helps in changing graph type without calling api again
  //   // dateHash
  //   // TODO: Remove after the conclusion on inline filter
  //   selectedEdition && selectedEdition.value,
  //   selectedInlineZone,
  //   hasClientAndEntity,
  //   selectedMainPublication,
  //   selectedInlinePublication,
  //   selectedInlineJournalist,
  //   selectedInlineWCType,
  //   selectedInlineSentiment,
  //   selectedMainSentiment,
  //   selectedMainEdition,
  //   selectedInlinePlatform,
  //   selectedMainCountry,
  //   selectedInlineEntity,
  //   selectedInlineWCEntity,
  //   selectedInlineInfluencerEntity,
  //   topicId,
  //   selectedInlineGenre,
  //   selectedInlineDynamicFilter,
  //   selectedInlineGraphType,
  // ]);

  useEffect(() => {
    //Clears Stored Data from previous API call
    setRawDataApiResponse(undefined);
    setNewApiRequest(true);
    setDatasetIndex(0);
    setShowPagination(false);
    return;
  }, [dateHash, chartType]);

  useEffect(() => {
    if (rawDataApiResponse && !newApiRequest) {
      //Formatss current graph with available data
      drawGraph(rawDataApiResponse);
    } else if (newApiRequest) {
      //Gets New Data
      setNewApiRequest(false);
      fetchGraph();
    } else {
      return;
    }
  }, [
    id,
    dateHash,
    datasetIndex,
    reportType,
    newApiRequest,
    selectedInlineDynamicFilter,
    selectedInlineGraphType,
    selectedInlineSentiment,
    selectedInlineEntity,
    selectedInlinePublicationGenre,
    selectedInlineSpokesperson,
  ]);

  useEffect(() => {
    //Draws Graph
    rawDataApiResponse && drawGraph(rawDataApiResponse);
  }, [rawDataApiResponse]);

  useEffect(() => {
    setShowPercentage;
    if (type == V_PRINT || type == V_ONLINE) {
      setEntityListByType(entityList);
    }
    if (type == V_SOCIAL || type == V_BLOG || type == V_FORUM) {
      setEntityListByType(socialEntityList);
    }
  }, [type]);

  useEffect(() => {
    isEmbededWidget && setSelectedInlineGraphType(selectedEmbededGraphType);
  }, [selectedEmbededGraphType]);

  useEffect(() => {
    setShowPercentage(selectedDataType === DATA_TYPES.PERCENTAGE);
  }, [selectedDataType]);

  useEffect(() => {
    setShowPercentage(value_type == DATA_TYPES.P_TEXT);
  }, [value_type]);

  useEffect(() => {
    setIsSameDateReport(moment(to_date).isSame(moment(from_date), "day"));
  }, [to_date, from_date]);

  if (!reportType) {
    return null;
  }

  const drawGraph = (response) => {
    const res = formatedData(response);
    if (Array.isArray(res)) {
      res[datasetIndex]?.hcPieChartData?.sort((a, b) => b.y - a.y);
      console.log("Recieved array", res);
      setDatasetLength(res.length);
      res.length > 1 && setShowPagination(true);
      setGraphApiResponse(res[datasetIndex]);
    } else {
      setGraphApiResponse(res);
      setShowPagination(false);
    }
  };

  function getTimelineText() {
    let defText = "Report for the duration ";
    if (moment(to_date).isSame(moment(from_date), "day")) {
      defText = `${defText}${getTrendGraphDateFormat(
        from_date,
        null,
        "Do MMMM YYYY"
      )}`;
    } else {
      defText = `${defText}${dateHash}`;
    }
    return defText;
  }
  function getInlineFilterText() {
    try {
      let text = `Media Type- ${VERTICAL_NAMES[widget.type]} | `;
      if (selectedInlineJournalist && selectedInlineJournalist.label) {
        text += `Journalist- ${selectedInlineJournalist.label} | `;
      }
      if (selectedInlinePlatform) {
        text += `Platform- ${selectedInlinePlatform} | `;
      }
      if (selectedInlinePublication && selectedInlinePublication.length) {
        text += `Publication- ${selectedInlinePublication.join(",")} | `;
      }
      if (selectedInlineSentiment) {
        text += `Sentiment- ${selectedInlineSentiment} | `;
      }
      if (selectedInlineSpokesperson) {
        text += `Spokesperson - ${selectedInlineSpokesperson} |`;
      }
      if (
        widget.graph_type == WORD_CLOUD &&
        (isBlogAndForum || isSocial) &&
        selectedInlineWCType &&
        selectedInlineWCType.label
      ) {
        text += `${selectedInlineWCType.label}  `;
      }
      return text.slice(0, -2);
    } catch (e) {
      console.warn("[Error @ widget inline filter text]: ", e);
      return "";
    }
  }

  function getTimelineTextPosition(str) {
    // console.log("getTimelineTextPosition", str, str.length);
    return 725 - str.length * 2.5;
    // if (moment(to_date).isSame(moment(from_date), "day")) {
    //   return 620;
    // } else {
    //   return 570;
    // }
  }

  function getCorrectPublication() {
    // selectedMainPublication => Top level analysis filter.
    // selectedInlinePublication => Widget level inline filter.
    if (!selectedMainPublication && !selectedInlinePublication) {
      return null;
    }

    if (selectedInlinePublication && selectedInlinePublication.value) {
      return [selectedInlinePublication.value];
    }

    return Array.isArray(selectedMainPublication)
      ? selectedMainPublication.map((e) => e && e.id)
      : (selectedMainPublication && selectedMainPublication.id) || [];
  }

  function getCorrectEntity() {
    if (isAnalysisReport) {
      if (selectedInlineEntity) {
        return [selectedInlineEntity.value];
      }
      if (Array.isArray(topic_ids)) {
        return topic_ids;
      }
      return [];
    } else {
      if (widget.topic_ids) {
        return widget.topic_ids;
      }
      if (Array.isArray(selectedEntity)) {
        return selectedEntity.map((el) => el && el.id);
      } else {
        return [];
      }
    }
  }

  function getCorrectSourceId() {
    if (selectedInlineJournalist && selectedInlineJournalist.value) {
      return [selectedInlineJournalist.value];
    } else {
      return [];
    }
  }

  function getCorrectSentiment() {
    if (type == V_SOCIAL) {
      if (selectedMainSentiment && selectedMainSentiment.length) {
        return selectedMainSentiment;
      }
      if (selectedInlineSentiment && selectedInlineSentiment.value) {
        return [selectedInlineSentiment.value];
      }
    } else {
      if (selectedMainSentiment && selectedMainSentiment.length) {
        return selectedMainSentiment;
      }
      if (selectedInlineSentiment && selectedInlineSentiment.id) {
        return [selectedInlineSentiment.id];
      }
    }
    return null;
  }

  function getCorrectEdition() {
    if (selectedMainEdition && selectedMainEdition.length) {
      return [selectedMainEdition];
    }
    if (selectedEdition && selectedEdition.value) {
      return [selectedEdition.value];
    }
    return null;
  }

  function getCorrectChannelType(clickedCType) {
    if (type != V_SOCIAL) {
      return null;
    }
    const correctedCType = clickedCType || channel_type;
    const { FACEBOOK, INSTAGRAM, YOUTUBE, TWITTER } = SOCIAL_SOURCES;
    if (selectedInlinePlatform) {
      return [selectedInlinePlatform.value];
    }
    if (correctedCType) {
      // https://webonise.atlassian.net/browse/CB-642
      if (
        report_type == REPORT_TYPES.SOVTonality ||
        report_type == REPORT_TYPES.PLATFORM_TONALITY
      ) {
        if (Array.isArray(correctedCType)) {
          if (!correctedCType.length) {
            return [FACEBOOK, INSTAGRAM, TWITTER];
          } else {
            return correctedCType.map((elm) => (elm == YOUTUBE ? 99 : elm));
          }
        }
        // Returning garbage value to avoid youtube data when non of the platform is selected.
        if (correctedCType == YOUTUBE) return [99];
      } else
        return Array.isArray(correctedCType)
          ? correctedCType
          : [correctedCType];
    } else {
      if (
        report_type == REPORT_TYPES.SOVTonality ||
        report_type == REPORT_TYPES.PLATFORM_TONALITY
      ) {
        return [FACEBOOK, INSTAGRAM, TWITTER];
      }
      return null;
    }
  }
  function fetchGraph() {
    try {
      setIsLoading(true);
      const callApi =
        isPrintAndOnline && clientId && to_date && from_date && topic_ids;
      if (!callApi || !reportType || !hasClientAndEntity) {
        console.log("Missing params");
        return;
      }
      initRef.current = true;
      const {
        graphDataType: { print, online, printandonline },
      } = reportType;
      // const params = {
      //   client_id: client_id || clientId,
      //   fromDate: formatDate(from_date, DATE_FORMATS.YYYYMMDD_dash),
      //   toDate: formatDate(to_date, DATE_FORMATS.YYYYMMDD_dash),
      //   getreport: "",
      //   graphs_data: type == V_PRINT ? print : online,
      //   media_type: String(type),
      //   user_id: user_id || getConceptUserId(),
      // };
      const params = {
        client_id: client_id || clientId,
        fromDate: formatDate(from_date, DATE_FORMATS.YYYYMMDD_dash),
        toDate: formatDate(to_date, DATE_FORMATS.YYYYMMDD_dash),
        getreport: "",
        graphs_data:
          type == V_PRINT_AND_ONLINE
            ? printandonline
            : type == V_PRINT
              ? print
              : online,
        media_type: String(type),
        user_id: user_id || getConceptUserId(),
        entity: [],
        vertical:
          widget.selectedVerticalMain === undefined
            ? ""
            : widget.selectedVerticalMain,
      };
      const tempEntityList = getCorrectEntity();
      const tempSourceId = getCorrectSourceId();
      const tempPublication = getCorrectPublication();
      const tempSentiment = !tonality
        ? getCorrectSentiment()
        : selectedInlineSentiment && selectedInlineSentiment.id
          ? getCorrectSentiment()
          : CONSTANTS.TONALITY.map(({ id }) => id);
      const tempEdition = getCorrectEdition();
      if (tempSourceId && tempSourceId.length) {
        if (
          report_type == JournalistAnalysisPrint ||
          report_type == EditionWiseNOATrend
        ) {
          params.entity = tempSourceId;
        } else {
          params.source_ids = tempSourceId;
        }
      }
      if (tempPublication && tempPublication.length) {
        params.selected_publications = tempPublication;
      }
      if (publisher_type && publisher_type.length) {
        params.publisher_type = publisher_type;
      }
      if (tempEdition && tempEdition.length) {
        params.edition = tempEdition;
      }
      // if (
      //   tempEntityList &&
      //   tempEntityList.length &&
      //   report_type != JournalistAnalysisPrint &&
      //   report_type != EditionWiseNOATrend
      // ) {
      //   params.entity = tempEntityList;
      // }
      // if (tempSentiment && tempSentiment.length) {
      //   params.tonality_ids = tempSentiment;
      // }
      // if (selectedMainPressRelease && selectedMainPressRelease.length) {
      //   params.pressrelease_ids = [selectedMainPressRelease];
      // }
      // let url = envConfig.REPORTS;

      if (selectedPublicationId !== undefined) {
        params.publication_ids = selectedPublicationId;
      }
      if (selectedTonality !== undefined) {
        params.tonality = selectedTonality;
      }
      if (selectedEditions !== undefined) {
        params.edition = selectedEditions;
      }
      if (selectedJournlist !== undefined) {
        params.source = selectedJournlist;
      }
      if (tempSourceId && tempSourceId.length) {
        if (report_type == JournalistSentiment) {
          params.source = tempSourceId;
        }
      }
      // console.log(params);
      if (
        (reportType.reportCategory === REPORT_CATEGORIES.THEMATIC_ANALYSIS &&
          newApiRequest) ||
        (reportType.reportCategory === REPORT_CATEGORIES.GEOLOCATION &&
          type === V_ONLINE) ||
        (/geolocation/i.test(report_type) && /trend/i.test(report_type)) ||
        (/geolocation/i.test(report_type) && /tonality/i.test(report_type)) ||
        reportType.reportCategory === REPORT_CATEGORIES.PUBLICATION
      ) {
        setUseInlineDynamicFilter(true);
      }
      if (
        reportType.reportCategory === REPORT_CATEGORIES.JOURNALIST &&
        newApiRequest
      ) {
        setUseInlineDynamicFilter(true);
      }
      if (
        reportType.reportCategory === REPORT_CATEGORIES.KEYWORD_CLOUD &&
        newApiRequest
      ) {
        setUseInlineDynamicFilter(true);
      }
      const {
        url,
        graphs_data,
        category,
        subtype,
        indextype,
        extratype,
        media_type,
      } = getCorrectParamDetails(params.graphs_data);
      // console.log(url, params,"has come");
      params.graphs_data = graphs_data;
      if (indextype.length > 0) {
        params.indextype = indextype;
      }
      if (media_type !== -1) {
        params.media_type = media_type;
      }
      params.type = category;
      params.subtype = subtype;
      params.extratype = extratype;

      if (reportType.reportCategory === REPORT_CATEGORIES.SPOKESPERSON) {
        params.ranking = "noofarticle";
      }
      setCurrentParams(params);
      console.log("change unique api key");
      httpPost(
        `${url}`,
        params,
        {
          Authorization:
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjoiNCRhbWl0LmNsaWVudEBjb25jZXB0Yml1LmNvbSJ9.VeM2QtccR6VhDsa8vC1XHQjU0GQA-wmdJRPaA2_cXmk",
        },
        true,
        `${report_type}${type}`
      )
        .then((response) => {
          const {
            data: { result },
          } = response || {};
          if (result) {
            setPublications(
              result[result?.sequence[0]].returnData?.publications
            );
            setJournalist(result[result?.sequence[0]].returnData?.journalist);
            setSentimentList(result[result?.sequence[0]].returnData?.tonality);
            const entities = result[result?.sequence[0]].returnData?.entities;
            if (reportType.reportCategory === REPORT_CATEGORIES.SPOKESPERSON) {
              setSpokesPersonList(
                result[result?.sequence[0]].returnData?.spokespersons
              );
            }
            console.log("storing response for current chart");
            setRawDataApiResponse(result);
            //drawGraph(result);
            setIsLoading(false);
            // Graph always draws from redrawGraph, when rawDataapi state is updated
            // const res = formatedData(result);
            // setGraphApiResponse(res);

            const {
              graphDataType: { print, online },
            } = reportType;
          } else {
            console.log("[Error]", response);
          }
        })
        .catch(() => {
          setShowError(true);
        })
        .finally(() => {
          enableDownloadFn && enableDownloadFn(id);
          initRef.current = true;
        });
    } catch (e) {
      initRef.current = true;
      console.log("[Error]", e);
      setIsLoading(false);
    }
  }

  function formatTableData(d = [], report_type) {
    if (report_type === REPORT_TYPES.SNAPSHOT) {
      let array = [];
      let data = d && d["Snapshot"] && d["Snapshot"].returnData?.graphdata;
      data = Object.values(data).sort();
      return data;
    }

    if (report_type === REPORT_TYPES.STORYTABLE) {
      let array = [];
      let data = d && d["StoryTable"] && d["StoryTable"].returnData?.graphdata;
      let arrayn = [];
      Object.keys(data).map(function (key) {
        arrayn.push({
          name: key,
          direct: data[key]["Direct"] && data[key]["Direct"]["article_count"],
          indirect:
            data[key]["Indirect"] && data[key]["Indirect"]["article_count"],
          mentioned:
            data[key]["Mentioned"] && data[key]["Mentioned"]["article_count"],
        });
      });
      return arrayn;
    }

    return [];
  }
  function formatedData(d = []) {
    //console.log(reportType);
    //getting graphdatatype to format data
    const graphDataType = reportType.graphDataType;
    if (reportType.reportCategory === REPORT_CATEGORIES.SOV) {
      return formatSOVData(d, graphDataType);
    } else if (
      reportType.reportCategory === REPORT_CATEGORIES.THEMATIC_ANALYSIS
    ) {
      return formatThematicData(d, graphDataType);
    } else if (reportType.reportCategory === REPORT_CATEGORIES.GEOLOCATION) {
      return formatGeolocationData(d, graphDataType);
    } else if (reportType.reportCategory === REPORT_CATEGORIES.SENTIMENT) {
      return formatSentimentData(d, graphDataType);
    } else if (reportType.reportCategory === REPORT_CATEGORIES.SPOKESPERSON) {
      return formatSpokespersonData(d, graphDataType);
    } else if (reportType.reportCategory === REPORT_CATEGORIES.JOURNALIST) {
      return formatJournalistData(d, graphDataType);
    }
    if (reportType.reportCategory === REPORT_CATEGORIES.KEYWORD_CLOUD) {
      const result = d;
      setKeywordList(result[result?.sequence[0]].returnData?.keywords);

      return formatKeywordData(d, graphDataType);
    } else if (reportType.reportCategory === REPORT_CATEGORIES.PUBLICATION) {
      return formatPublicationData(d, graphDataType);
    } else {
      return d;
    }
    // if (reportType.reportCategory === "thematic") {
    //   return formatThematicData(d);
    // }
    // if (reportType.reportCategory === "geolocation") {
    //   return formatGeolocationData(d);
    // }

    // if (reportType.reportCategory === "keyword") {
    //   return formatKeywordData(d);
    // }
    // if (reportType.reportCategory === "SOVSnapshot") {
    //   return formatTableData(d, report_type);
    // }

    // if (reportType.reportCategory === "StoryTable") {
    //   return formatTableData(d, report_type);
    // }
    // if (reportType.reportCategory === "StoryPaticipate") {
    //   return formatStoryParticipationData(d, selectedInlineGraphType);
    // }

    // if (reportType.reportCategory === "journalist") {
    //   return formatedDataByJournalist(
    //     d,
    //     selectedInlineGraphType,
    //     isLineGraph,
    //     type,
    //     report_type
    //   );
    // }
    // if (reportType.reportCategory === "sentiment") {
    //   return formatSentimentData(
    //     d,
    //     selectedInlineGraphType,
    //     isLineGraph,
    //     type,
    //     report_type
    //   );
    // }
    // if (reportType.reportCategory === "sentimentTable") {
    //   return formatSentimentTableData(
    //     d,
    //     selectedInlineGraphType,
    //     isLineGraph,
    //     type,
    //     report_type
    //   );
    // }
    // if (reportType.reportCategory === "JournalistSentiment") {
    //   return formatJournalistSentimentData(d, selectedInlineGraphType);
    // }

    // if (reportType.reportCategory === "spokesperson") {
    //   return formatSpokesPersonData(
    //     d,
    //     selectedInlineGraphType,
    //     isLineGraph,
    //     type,
    //     report_type
    //   );
    // }

    // return formatDataByRanking(
    //   d,
    //   selectedInlineGraphType,
    //   isLineGraph,
    //   type,
    //   report_type
    // );
  }

  function formatSOVData(d, graphDataType) {
    const entities = getEntitiesFromResponse(d);
    entities && setDynamicEntityList(entities);

    return newFormatSOVData(
      d,
      report_type,
      graphDataType,
      selectedInlineGraphType,
      selectedInlineSentiment,
      selectedInlineEntity
    );
  }
  function formatSentimentData(d, graphDataType) {
    const entities = getEntitiesFromResponse(d);
    entities && setDynamicEntityList(entities);
    return newFormatDataBySentiment(
      d,
      selectedInlineGraphType,
      report_type,
      selectedInlineSentiment,
      graphDataType,
      selectedInlineEntity
    );
  }
  function formatSpokespersonData(d, graphDataType) {
    const entities = getEntitiesFromResponse(d);
    entities && setDynamicEntityList(entities);
    return newFormatDataBySpokesperson(
      d,
      selectedInlineGraphType,
      report_type,
      selectedInlineSpokesperson,
      graphDataType,
      selectedInlineEntity
    );
  }

  function formatJournalistData(d, graphDataType) {
    if (useInlineDynamicFilter) {
      const journalist = getJournalistFromResponse(d);
      console.log(journalist);
      journalist && setDynamicFilterList(journalist.map((j) => j.source_name));
      journalist[0] &&
        setSelectedInlineDynamicFilter({
          value: journalist[0].source_name,
          label: journalist[0].source_name,
        });
      setUseInlineDynamicFilter((prev) => !prev);
    }
    const entities = getEntitiesFromResponse(d);
    entities && setDynamicEntityList(entities);
    return newFormatDataByJournalist(
      d,
      report_type,
      graphDataType,
      selectedInlineGraphType,
      selectedInlineSentiment,
      selectedInlineEntity,
      selectedInlineDynamicFilter
    );
  }
  function formatKeywordData(d, graphDataType) {
    if (useInlineDynamicFilter) {
      const keyword = getKeywordFromResponse(d, graphDataType);
      keyword && setDynamicFilterList(keyword);
      setSelectedInlineDynamicFilter({
        value: keyword[0],
        label: keyword[0],
      });
      setUseInlineDynamicFilter((prev) => !prev);
    }
    return newFormatDataByKeyword(
      d,
      report_type,
      graphDataType,
      selectedInlineGraphType,
      selectedInlineSentiment,
      selectedInlineEntity,
      selectedInlineDynamicFilter
    );
  }
  function formatThematicData(d, graphDataType) {
    if (useInlineDynamicFilter && /newentity/i.test(report_type) === false) {
      const themes = getThemesFromResponse(d);
      themes && setDynamicFilterList(themes);
      setSelectedInlineDynamicFilter((prev) => {
        return { label: "Select Theme", value: themes[0] };
      });
      setUseInlineDynamicFilter((prev) => !prev);
    }
    const entities = getEntitiesFromResponse(d);
    entities && setDynamicEntityList(entities);
    return newFormatThematicData(
      d,
      report_type,
      graphDataType,
      selectedInlineGraphType,
      selectedInlineSentiment,
      selectedInlineEntity,
      selectedInlineDynamicFilter
    );
  }

  function formatGeolocationData(d, graphDataType) {
    if (useInlineDynamicFilter && /newentity/i.test(report_type) === false) {
      const zones = getZonesFromResponse(d);
      zones && setDynamicFilterList(zones);
      setSelectedInlineDynamicFilter((prev) => {
        return { label: "Select Zone", value: zones[0] };
      });
      setUseInlineDynamicFilter((prev) => !prev);
    }
    const entities = getEntitiesFromResponse(d);
    entities && setDynamicEntityList(entities);
    return newFormatGeolocationData(
      d,
      report_type,
      type,
      selectedInlineGraphType,
      selectedInlineSentiment,
      selectedInlineEntity,
      selectedInlineDynamicFilter
    );
  }

  function formatPublicationData(d) {
    if (useInlineDynamicFilter && /newentity/i.test(report_type) === false) {
      const publications = getPublicationsFromResponse(d);
      publications && setDynamicFilterList(publications);
      setSelectedInlineDynamicFilter((prev) => {
        return { label: "Select Publication", value: publications[0] };
      });
      // if (/trend/i.test(report_type) && !/Entity/.test(report_type)) {
      //   const list = (/Keyword/.test(report_type)) ? getKeywordsFromResponse(d) : getJournalistFromResponse(d).map((j) => j.source_name);
      //   list && setDynamicFilterList(list);
      //   setSelectedInlineDynamicFilter({ label: list[0], value: list[0] });
      // }
      setUseInlineDynamicFilter((prev) => !prev);
    }
    const entities = getEntitiesFromResponse(d);
    entities && setDynamicEntityList(entities);
    return newFormatPublicationData(
      d,
      report_type,
      type,
      selectedInlineGraphType,
      selectedInlineSentiment,
      selectedInlineEntity,
      selectedInlineDynamicFilter,
      selectedInlinePublicationGenre
    );
  }

  function getWCTextPos(imgPos) {
    let textOffset = 0;
    if (isSameDateReport) {
      textOffset = isEmbededWidget ? 50 : 70;
    } else {
      textOffset = isEmbededWidget ? 110 : 90;
    }
    return imgPos - textOffset;
  }

  function svgDownload() {
    try {
      const uniqueIdentifier = isEmbededWidget
        ? `embedded-${identifier}`
        : identifier;
      const svg = document
        .getElementById(uniqueIdentifier)
        .querySelector("svg");
      if (svg) {
        const canvas = document.createElement("canvas");
        const width = svg ? svg.width.animVal.value : 600;
        const height = svg ? svg.height.animVal.value + 200 : 600;
        canvas.width = width;
        canvas.height = height;
        let logoLoaded = false;
        const ctx = canvas.getContext("2d");
        const data = new XMLSerializer().serializeToString(svg);
        const DOM_URL = window.URL || window.webkitURL;
        const img = new Image();
        const biuLogoImg = new Image();
        biuLogoImg.src = biuLogo;
        biuLogoImg.onload = () => {
          logoLoaded = true;
          console.log(" logo loaded:");
        };
        const svgBlob = new Blob([data], {
          type: "image/svg+xml;charset=utf-8",
        });
        const url = DOM_URL.createObjectURL(svgBlob);
        const imagePostion = canvas.width / 2 - 25;
        const textPosition = getWCTextPos(imagePostion);
        img.onload = function () {
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 100);
          ctx.drawImage(biuLogoImg, imagePostion, 5, 50, 50);
          ctx.stroke();
          ctx.font = "12px Arial";
          ctx.strokeText(getTimelineText(), textPosition, 70);
          ctx.textAlign = "center";
          ctx.strokeText(getInlineFilterText(), canvas.width / 2, 90);
          ctx.textAlign = "center";
          var imgURI = canvas.toDataURL("image/png");
          const a = document.createElement("a");
          a.href = imgURI;
          a.download = `${chartTitle}.png`;
          a.click();
        };
        img.src = url;
      }
    } catch (e) {
      throw ("SVG Download failed", e);
    }
  }

  function formatCSVData(inputData) {
    let fieldsToDelete = [
      "entity_id",
      "source_id",
      "entity_group",
      "client_id",
      "laguage_id",
      "topic_id",
      "topic_category",
      "publication_id",
      "mavcntkh",
      "ccmcntlkh",
      "Not Rated",
    ];
    const fieldsToReplace = {
      articlecnt: "Count",
      entity: "Company",
      publish_date: "Publish Date",
      source_name: "Journalist",
      language_name: "Language",
      percentage: "Percentage",
      topic_name: "Company",
      post_count: "Count",
      keyword: "Keyword",
      online_cnt: "Count",
      print_cnt: "Count",
      publication_name: "Publication",
      from_username: "Name",
      count: "Count",
      followers_count: "Followers",
      reach_count: "Reach",
      wordcountsum: "Word Count",
      ccmcnt: "CCM Count",
      mavcnt: "MAV Count",
      ccm: "CCM Count",
      mav: "MAV Count",
      ccmsum: "CCM",
      mavsumlkh: "MAV",
      channel_type: "Platform",
      created_at: "Publish Date",
      tonality: "Sentiment",
      Informative: "Neutral",
    };
    if (widget.graph_type === CHOROPLETH) {
      try {
        const gd = groupBy(inputData, "country");
        inputData = Object.keys(gd).map((country) => {
          return {
            Country: country,
            Count: gd[country].length,
          };
        });
      } catch {
        return;
      }
    }
    if (
      widget.graph_type === WORD_CLOUD &&
      (widget.type === V_PRINT || widget.type === V_ONLINE)
    ) {
      fieldsToDelete.push(widget.type === V_PRINT ? "online_cnt" : "print_cnt");
    }
    const fieldsToReplaceKeys = Object.keys(fieldsToReplace);
    if (Array.isArray(inputData)) {
      const dataKeys = Object.keys(inputData[0]);
      if (
        dataKeys.indexOf("post_count") !== -1 ||
        dataKeys.indexOf("data") !== -1
      ) {
        const sortKey =
          dataKeys.indexOf("post_count") !== -1 ? "post_count" : "data";
        inputData = inputData.sort((a, b) => {
          return b[sortKey].length - a[sortKey].length;
        });
      }
    }
    return inputData.map((ele) => {
      fieldsToDelete.forEach((fd) => delete ele[fd]);
      const eleKeys = Object.keys(ele);
      const obj = {};
      eleKeys.forEach((eleKey) => {
        if (
          ("post_count" === eleKey && typeof ele[eleKey] === "object") ||
          ("data" === eleKey && typeof ele[eleKey] === "object")
        ) {
          ele[eleKey].forEach((tc) => {
            if (
              tc.tonality ||
              tc.created_at ||
              tc.keyword ||
              tc.channel_type ||
              tc.lang
            ) {
              let channelType = "";
              if (tc.channel_type) {
                const pId = SOCIAL_SOURCES_OPTIONS.find(
                  (e) => e.value == tc.channel_type
                );
                channelType = pId ? pId.label : "";
              }
              obj[
                tc.tonality ||
                tc.keyword ||
                channelType ||
                tc.lang ||
                moment(tc.created_at).format("DD-MM-YYYY")
              ] = tc.count || 0;
            }
          });
          return;
        }
        if (fieldsToReplaceKeys.indexOf(eleKey) !== -1) {
          if (eleKey === "publish_date" || eleKey === "created_at") {
            obj[fieldsToReplace[eleKey]] = moment(ele[eleKey]).format(
              "DD-MM-YYYY"
            );
          } else if (eleKey === "channel_type") {
            const pId = SOCIAL_SOURCES_OPTIONS.find(
              (e) => e.value == ele[eleKey]
            );
            obj[fieldsToReplace[eleKey]] = pId ? pId.label : "NA";
          } else {
            obj[fieldsToReplace[eleKey]] = ele[eleKey];
          }
        } else {
          obj[eleKey] = ele[eleKey];
        }
      });
      return obj;
    });
  }

  function getDateDiff(toDate, fromDate) {
    const t = moment(toDate, "MM-DD-YYYY");
    const f = moment(fromDate, "MM-DD-YYYY");
    const diff = t.diff(f, "days");
    return diff;
  }

  function downloadCsv(fName) {
    try {
      if (
        (!dataByReportType.length &&
          !(
            rawDataApiResponse &&
            rawDataApiResponse.graph_data &&
            rawDataApiResponse.graph_data.length
          ) &&
          (!worldMapData || !worldMapData.length)) ||
        showError
      ) {
        // no data
        return;
      }
      let dt = dataByReportType.length
        ? dataByReportType
        : worldMapData.length
          ? worldMapData
          : rawDataApiResponse.graph_data;

      if (
        widget.graph_type === TABLE &&
        graphApiResponse &&
        graphApiResponse.length
      ) {
        dt = graphApiResponse;
      }
      if (widget.report_type === REPORT_TYPES.PLATFORM_TONALITY) {
        dt = dt
          .map((et) =>
            et.post_count
              .map((pc) => ({
                topic_name: et.topic_name,
                channel_type: pc.channel_type,
                tonality: pc.tonality,
                count: pc.count,
              }))
              .flat()
          )
          .flat();
      }
      if (widget.report_type === REPORT_TYPES.PLATFORM_TREND) {
        dt = dt
          .map((et) =>
            et.post_count
              .map((pc) =>
                pc.data.map((dt) => ({
                  topic_name: et.topic_name,
                  channel_type: pc.channel_type,
                  created_at: dt.created_at,
                  count: dt.count,
                }))
              )
              .flat()
          )
          .flat();
      }

      // To remove unwanted fields from report CSV.
      dt = dt.map((d) => {
        PRINT_ONLINE_COUNT_KEYS.forEach((pk) => {
          if (pk !== reportType.countKey) {
            delete d[pk];
          }
        });
        return d;
      });

      const csvData = formatCSVData(dt);
      let fields = [];
      csvData.forEach((cd) => {
        fields = [...fields, ...Object.keys(cd)].filter(onlyUnique);
      });
      const FROM_DATE = moment(from_date).format("DD-MM-YYYY");
      const TO_DATE = moment(to_date).format("DD-MM-YYYY");
      const diffInDays = getDateDiff(to_date, from_date);
      let csvContent = "";
      if (reportType && reportType.label) {
        csvContent = `,,Report - ${reportType.label} \n`;
      }
      if (selectedInlineJournalist && !!selectedInlineJournalist.label) {
        csvContent += `,,Journalist - ${selectedInlineJournalist.label} \n`;
      }
      if (selectedInlinePlatform && selectedInlinePlatform.label) {
        csvContent += `,,Platform - ${selectedInlinePlatform.label} \n`;
      }
      if (selectedInlinePublication && selectedInlinePublication.label) {
        csvContent += `,,Publication - ${selectedInlinePublication.label} \n`;
      }
      if (selectedInlineSentiment && selectedInlineSentiment.label) {
        csvContent += `,,Sentiment - ${selectedInlineSentiment.label} \n`;
      }
      if (selectedEdition && selectedEdition.label) {
        csvContent += `,,Edition - ${selectedEdition.label} \n`;
      }
      csvContent += `,,Report for the duration ${diffInDays > 0 ? FROM_DATE + " to " + TO_DATE : FROM_DATE
        } \n\n\n`;

      csvContent += fields.join(",") + "\n";

      csvData.forEach((ele) => {
        let eleFields = fields.map((fieldEle) => {
          return ele[fieldEle] || "0";
        });
        csvContent += eleFields.join(",") + "\n";
      });
      const a = document.createElement("a");
      // replace is to get rid of # breaking the CSV
      const encodedContent = encodeURI(csvContent).replaceAll("#", "%23");
      a.href = `data:text/csv;charset=utf-8,\uFEFF${encodedContent}`;
      a.download = `${fName}.csv`;
      a.click();
    } catch {
      console.log("Error while downloading csv");
    }
  }

  function downloadChart(fName) {
    try {
      if (reportType.id == REPORT_TYPES.TotalMediaExposure) {
        const doc = new jsPDF();
        doc.autoTable({ html: `#${identifier}` });
        doc.save(fName);
        return;
      }
      if (
        reportType.id == REPORT_TYPES.KeywordCloudNOA ||
        reportType.id == REPORT_TYPES.WorldMap
      ) {
        svgDownload();
        return;
      }
      graphRef.current.chart.exportChart();
    } catch (e) {
      alert("Failed to download chart");
      console.error(e);
    }
  }
  const resolveSentiment = (tone) => {
    const tempTone = TONALITY_FILTER.values.filter((t) => t.id == tone);
    if (tempTone && tempTone[0]) {
      return tempTone[0].text;
    }
    return null;
  };

  function gotoWidgetDetails({
    edition,
    sourceName,
    date,
    entityId,
    tagFilterName,
    publication,
    publicationType,
    tonality,
    language,
    keyword,
    spokesperson,
    topic,
    profile,
    country,
    countryFeeds,
    channelType,
    from_username,
    zone,
    media_type,
    theme,
    ent,
    categoryId,
  } = {}) {
    let defaultData = { ...widget };
    // console.log(sourceName);
    if (tonality) {
      defaultData.tonality = tonality;
    }

    if (date) {
      defaultData.date = date;
    }
    if (entityId) {
      defaultData.entityId = [entityId.toString()];
      defaultData.topic_ids = [entityId.toString()];
    }
    if (publication) {
      defaultData.publication = publication;
    }
    if (publicationType) {
      defaultData.publication_type = publicationType;
    }
    if (sourceName) {
      defaultData.journalist = sourceName;
    }
    if (zone) {
      defaultData.zone = zone;
    }
    if (media_type) {
      defaultData.media_type = media_type;
    }
    if (publicationList) {
      defaultData.publicationList = publicationList;
    }
    if (journaList) {
      defaultData.journalistList = journaList;
    }
    if (editionList) {
      defaultData.editionList = editionList;
    }
    if (theme) {
      defaultData.theme = theme;
    }
    if (spokesperson) {
      defaultData.spokesperson = spokesperson;
    }
    if (topic) {
      defaultData.topic = topic;
    }
    if (profile) {
      defaultData.profile = profile;
    }
    const tempSourceId = getCorrectSourceId();
    if (
      (report_type == JournalistAnalysisPrint ||
        report_type == EditionWiseNOATrend) &&
      tempSourceId &&
      tempSourceId.length
    ) {
      defaultData.entityId = tempSourceId;
      defaultData.topic_ids = tempSourceId;
    }
    if (tagFilterName) {
      defaultData.filterTags = [tagFilterName];
    }
    if (keyword) {
      defaultData.keyword = keyword;
    }
    if (country && countryFeeds) {
      defaultData.worldMapData = {
        countryFeeds,
        country,
      };
    }
    if (edition) {
      defaultData.edition = edition;
    }

    defaultData.channel_type = getCorrectChannelType(channelType);

    if (from_username) {
      defaultData.from_username = from_username;
    }

    if (isAnalysisReport && selectedMainCountry) {
      defaultData.country = selectedMainCountry;
    }

    const correctEntityList = entityListByType;
    const clickedEntity =
      correctEntityList &&
      correctEntityList.filter((e) => {
        if (e && e.id && e.id == entityId) {
          return e.entity_name || e.name;
        }
      });

    defaultData.useMutipleTopicsApi =
      (report_type == REPORT_TYPES.KeywordCloudNOA ||
        report_type == REPORT_TYPES.TopLanguages) &&
      !isPrintAndOnline;
    defaultData.selectedInlineWCType = selectedInlineWCType;
    const lang = dataByReportType.find((elm) => elm.laguage_id == language);
    const clickedLanguage =
      type == V_ONLINE || type == V_PRINT
        ? (lang && lang.language_name) || ""
        : language;
    // Since, such reports are queried by clicked language and the entities == the entities contributed to the widget.
    defaultData.clickedEntityName =
      country ||
      keyword ||
      clickedLanguage ||
      (Array.isArray(clickedEntity) &&
        clickedEntity[0] &&
        (clickedEntity[0].entity_name || clickedEntity[0].name));
    if (!isEmbededWidget) {
      setFeedsParams(defaultData);
      setShowFeedsList(true);
    }
    if (isEmbededWidget && setEmbededFeedsParams) {
      setEmbededFeedsParams(defaultData);
    }
  }

  function onEntityClick(e, routeParams) {
    if (
      // /Entity/.test(report_type) &&
      /Tonality/.test(report_type) &&
      /SOV/.test(report_type) &&
      selectedInlineGraphType === PIE
    ) {
      routeParams.tonality = selectedInlineSentiment.value;
    }
    if (
      (/Tonality/.test(report_type) &&
        /Geolocation/.test(report_type) &&
        ((/Entity/i.test(report_type) && type !== V_PRINT) ||
          /publication/i.test(report_type) ||
          /keyword/i.test(report_type))) ||
      (/Journalist/.test(report_type) &&
        /Tonality/.test(report_type) &&
        /Keyword/.test(report_type)) ||
      (/Thematic/.test(report_type) &&
        /Tonality/.test(report_type) &&
        !/Entity/.test(report_type)) ||
      /^Sentiment/.test(report_type)
    ) {
      if(!routeParams.tonalityConditon){
        routeParams.tonality = selectedInlineSentiment.value;
      }
    }
    if (
      reportType.reportCategory === REPORT_CATEGORIES.JOURNALIST &&
      (((/SOV/.test(report_type) || /Tonality/.test(report_type)) &&
        /Keyword/.test(report_type)) ||
        /Trend/.test(report_type) ||
        (/Entity/.test(report_type) && !/SOV/.test(report_type)))
    ) {
      if (
        !(/Journalist/i.test(report_type) && /Publication/.test(report_type))
      ) {
        routeParams.sourceName = selectedInlineDynamicFilter.value;
        console.log("source name changed dynamic");
      }
    }
    if (
      reportType.reportCategory === REPORT_CATEGORIES.GEOLOCATION &&
      type !== V_ONLINE &&
      (/trend/i.test(report_type) || /tonality/i.test(report_type))
    ) {
      routeParams.zone = selectedInlineDynamicFilter.value;
    }
    if (
      reportType.reportCategory === REPORT_CATEGORIES.PUBLICATION &&
      (/SOV/.test(report_type) ||
        /Tonality/.test(report_type) ||
        /Trend/.test(report_type)) &&
      (/Entity/.test(report_type) ||
        /Keyword/.test(report_type) ||
        /Journalist/.test(report_type))
    ) {
      routeParams.publicationType = selectedInlinePublicationGenre.value;
      if (/Tonality/.test(report_type)) {
        routeParams.tonality = selectedInlineSentiment.value;
      }
      if (/Trend/.test(report_type)) {
        routeParams.publication = selectedInlineDynamicFilter.value;
      }
    }
    if (
      reportType.reportCategory === REPORT_CATEGORIES.THEMATIC_ANALYSIS &&
      (!/Entity/.test(report_type) ||
        selectedInlineGraphType === PIE ||
        /Trend/.test(report_type) ||
        /Tonality/.test(report_type))
    ) {
      routeParams.theme = selectedInlineDynamicFilter.value;
    }
    if (reportType.reportCategory === REPORT_CATEGORIES.KEYWORD_CLOUD) {
      if (
        (!/Entity/.test(report_type) && /SOV/.test(report_type)) ||
        /Trend/.test(report_type) ||
        /Tonality/.test(report_type)
      ) {
        routeParams.keyword = selectedInlineDynamicFilter.value;
      }
      if (!/Entity/.test(report_type) && /Tonality/.test(report_type)) {
        routeParams.tonality = selectedInlineSentiment.value;
      }
    }
    if (
      reportType.reportCategory === REPORT_CATEGORIES.SPOKESPERSON &&
      ((/SOV/.test(report_type) && !/Entity/.test(report_type)) ||
        /Trend/.test(report_type))
    ) {
      routeParams.spokesperson = selectedInlineSpokesperson.value;
    }
    //add dynamic selected entity to params
    if (
      (/ranking/i.test(report_type) &&
        /sov/i.test(report_type) &&
        /publication/i.test(report_type) &&
        selectedInlineGraphType === PIE) || //!/ranking/i.test(report_type) ||
      ((/trend/i.test(report_type) || /tonality/i.test(report_type)) &&
        /sov/i.test(report_type) &&
        /publication/i.test(report_type)) ||
      (/sov/i.test(report_type) &&
        /journalist/i.test(report_type) &&
        selectedInlineGraphType === PIE) ||
      (/sov/i.test(report_type) &&
        /journalist/i.test(report_type) &&
        (/trend/i.test(report_type) || /tonality/i.test(report_type))) ||
      (/sov/i.test(report_type) &&
        /city/i.test(report_type) &&
        selectedInlineGraphType === PIE) ||
      (/sov/i.test(report_type) &&
        /city/i.test(report_type) &&
        (/trend/i.test(report_type) || /tonality/i.test(report_type))) ||
      (/sov/i.test(report_type) &&
        /keyword/i.test(report_type) &&
        selectedInlineGraphType === PIE) ||
      (/sov/i.test(report_type) &&
        /keyword/i.test(report_type) &&
        (/trend/i.test(report_type) || /tonality/i.test(report_type))) ||
      (/geolocation/i.test(report_type) &&
        !/tonality/i.test(report_type) &&
        (/keyword/i.test(report_type) ||
          /publication/i.test(report_type) ||
          (/trend/i.test(report_type) && type === V_ONLINE))) ||
      (/journalist/i.test(report_type) &&
        /trend/i.test(report_type) &&
        /keyword/i.test(report_type)) ||
      (reportType.reportCategory === REPORT_CATEGORIES.PUBLICATION &&
        (/SOV/.test(report_type) ||
          /Tonality/.test(report_type) ||
          /Trend/.test(report_type)) &&
        (/Keyword/.test(report_type) || /Journalist/.test(report_type))) ||
      (/Thematic/.test(report_type) &&
        /Trend/.test(report_type) &&
        !/Entity/.test(report_type)) ||
      (reportType.reportCategory === REPORT_CATEGORIES.KEYWORD_CLOUD &&
        /Trend/.test(report_type) &&
        !/Entity/.test(report_type)) ||
      (reportType.reportCategory === REPORT_CATEGORIES.SENTIMENT &&
        !/Entity/.test(report_type) &&
        (/Trend/.test(report_type) || selectedInlineGraphType === PIE)) ||
      (reportType.reportCategory === REPORT_CATEGORIES.SPOKESPERSON &&
        /Trend/.test(report_type) &&
        !/Entity/.test(report_type))
    ) {
      let entity =
        entityList &&
        entityList.filter(
          (elm) => selectedInlineEntity.value == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
    }
    try {
      gotoWidgetDetails(routeParams);
    } catch (err) {
      console.error("Error in contributed feeds : ", err);
      return;
    }
  }

  // function formatWordCloudData(d) {
  //   try {
  //     const {
  //       graphDataType: { print, online },
  //     } = reportType;
  //     let countKey = "online_cnt";
  //     let rType = online;
  //     if (type == V_PRINT) {
  //       countKey = "print_cnt";
  //       rType = print;
  //     }
  //     const isBothMediatype = type == V_PRINT_AND_ONLINE;
  //     const dataByReportType = d[rType] && d[rType].returnData;
  //     const data = dataByReportType.map((el) => {
  //       const val = isBothMediatype
  //         ? parseInt(el["print_cnt"], 10) + parseInt(el["online_cnt"], 10)
  //         : parseInt(el[countKey], 10);
  //       return {
  //         name: el.keyword,
  //         weight: val,
  //       };
  //     });
  //     return data.filter((elm) => elm.weight);
  //   } catch (e) {
  //     return {
  //       name: "",
  //       weight: 0,
  //     };
  //   }
  // }

  function onWidgetDelete(id) {
    if (!id) {
      return;
    }
    setDeleteId(id);
    setShowDeleteConfirm(true);
  }

  const renderInlineGraphTypeSwitch = useCallback(() => {
    if (inlineGraphTypeOptions && inlineGraphTypeOptions.length) {
      let inlineOpts = [...inlineGraphTypeOptions].filter(
        (igtOpts) => igtOpts.value !== TABLE && igtOpts
      );
      return inlineOpts.map((gType) => {
        const isChecked = selectedInlineGraphType
          ? selectedInlineGraphType == gType.value
          : graph_type == gType.value;

        return (
          <React.Fragment key={`${isChecked}${gType.value}`}>
            <Dropdown.Item className="diWithRadio">
              <label
                className="inputWrap"
                onClick={() => setSelectedInlineGraphType(gType.value)}
              >
                {gType.label}
                <input type="radio" checked={isChecked} />
                <span className="checkmark"></span>
              </label>
            </Dropdown.Item>
          </React.Fragment>
        );
      });
    }
    return null;
  }, [inlineGraphTypeOptions, selectedInlineGraphType]);

  // const getCorrectTittle = (type, report) => {
  //   if (type === V_PRINT && report === "PublicationNOARanking") {
  //     return "Top Publications (Articles)";
  //   } else if (type === V_PRINT && report === "PublicationNOATrend") {
  //     return "Publications by Trend (Articles)";
  //   } else return reportType && reportType.label;
  // };

  const updateDatasetIndex = (idx) => {
    console.log(idx);
    setDatasetIndex(idx - 1);
    // if (set === "prev") {
    //   if (datasetIndex === 0) {
    //     setDatasetIndex(datasetLength - 1);
    //   } else {
    //     setDatasetIndex((prev) => prev - 1);
    //   }
    // } else {
    //   if (datasetIndex === datasetLength - 1) {
    //     setDatasetIndex(0);
    //   } else {
    //     setDatasetIndex((prev) => prev + 1);
    //   }
    // }
  };

  let chartTitle = useMemo(
    () =>
      getCorrectChartTitle(
        type,
        reportType,
        selectedInlineGraphType,
        selectedInlineDynamicFilter,
        selectedInlineEntity,
        selectedInlineSentiment,
        selectedInlineSpokesperson,
        selectedInlinePublicationGenre,
        datasetIndex
      ),
    [
      reportType,
      selectedInlineGraphType,
      selectedInlineDynamicFilter,
      selectedInlineEntity,
      selectedInlineSentiment,
      selectedInlineSpokesperson,
      selectedInlinePublicationGenre,
      datasetIndex,
    ]
  );

  const showChartValueOption =
    !isEmbededWidget &&
    (selectedInlineGraphType
      ? selectedInlineGraphType == PIE ||
      selectedInlineGraphType == DOUGHNUT ||
      selectedInlineGraphType == BAR_VERTICAL
      : graph_type == PIE ||
      graph_type == DOUGHNUT ||
      graph_type == BAR_VERTICAL);
  let isValidWidget =
    graphApiResponse &&
    graphApiResponse.datasets &&
    !!graphApiResponse.datasets.length &&
    graphApiResponse.labels &&
    !!graphApiResponse.labels.length;
  isValidWidget =
    graph_type == CHOROPLETH && worldMapData ? true : isValidWidget;

  // const setSelectedFilters = (e) => {
  //   const selectedF = e.value;
  //   setNewSelectedFilter(selectedF);
  //   if (selectedF === 6) {
  //     setShowPublication(false);
  //     setShowJournlist(false);
  //     setShowEdition(false);
  //     setShowKeyword(false);
  //   }
  //   if (selectedF === "publication") {
  //     setShowPublication(true);
  //     setShowJournlist(false);
  //     setShowEdition(false);
  //     setShowKeyword(false);
  //   }
  //   if (selectedF === "journalist") {
  //     setShowJournlist(true);
  //     setShowPublication(false);
  //     setShowEdition(false);
  //     setShowKeyword(false);
  //   }
  //   if (selectedF === "city") {
  //     setShowEdition(true);
  //     setShowPublication(false);
  //     setShowJournlist(false);
  //     setShowKeyword(false);
  //   }
  //   if (selectedF === "keyword") {
  //     setShowKeyword(true);
  //     setShowPublication(false);
  //     setShowJournlist(false);
  //     setShowEdition(false);
  //   }
  // };
  // console.log(twitterFeeds, isLoading, showError);
  // console.log(
  //   "!twitterFeeds && !isLoading && showError",
  //   !twitterFeeds && !isLoading && showError
  // );
  const dynamicEntityFilterList = useMemo(() => {
    return entityList && dynamicEntityList.length > 0
      ? entityList.filter(
        (entDetails) =>
          dynamicEntityList.indexOf(entDetails.entity_name) !== -1
      )
      : entityList;
  }, [entityList, dynamicEntityList]);

  const customWidget = widget
    ? { ...widget, graph_type: selectedInlineGraphType }
    : {};
  // const customWidget = isEmbededWidget ?
  //   useMemo(() => widget ? { ...widget, graph_type: selectedEmbededGraphType } : {}, [selectedEmbededGraphType]) :
  //   { ...widget, graph_type: selectedInlineGraphType };
  return (
    <div className="chartsContainer" ref={chartContainer}>
      <div className="chartsWrapper">
        <div className="chartActionWrap">
          {showFeedsList && embededEnabled && (
            <EmbededFeedsList
              feedsParams={feedsParams}
              onCancel={() => setShowFeedsList(false)}
              widget={customWidget}
              inlineGraphTypeOptions={inlineGraphTypeOptions}
              onWidgetDelete={onWidgetDelete}
              setWidgetCreationStatus={setWidgetCreationStatus}
              fetchWidgets={fetchWidgets}
              selectedDataType={
                showPercentage ? DATA_TYPES.PERCENTAGE : DATA_TYPES.NUMBER
              }
              isAnalysisReport={isAnalysisReport}
              selectedInlineEdition={selectedEdition}
              selectedInlinePublication={selectedInlinePublication}
              selectedInlineInfluencerEntity={selectedInlineInfluencerEntity}
              selectedInlineWCEntity={selectedInlineWCEntity}
              twitterFeeds={twitterFeeds}
              selectedFilter={
                selectedFilter && selectedFilter.label
                  ? selectedFilter.label
                  : selectedFilter
              }
              tabData={tabData}
              topicId={topicId}
              countType={countType}
              tonalities={tonality}
              widgetApiInProgress={widgetApiInProgress}
              startRange={startRange}
              endRange={endRange}
              currentParams={currentParams}
              routeParams={routeParams}
            />
          )}
          <div className="chartActionLeft">
            {reportType.reportCategory !== REPORT_CATEGORIES.GEOLOCATION && (
              <VerticalTag key={type} type={type} />
            )}
            {renderAnalysisWidget()}
            <WidgetInlineFilters
              editionList={editionList}
              selectedEdition={selectedEdition}
              setSelectedEdition={setSelectedEdition}
              widget={widget}
              selectedInlinePublication={selectedInlinePublication}
              setSelectedInlinePublication={setSelectedInlinePublication}
              selectedInlineJournalist={selectedInlineJournalist}
              setSelectedInlineJournalist={setSelectedInlineJournalist}
              selectedInlineEntity={selectedInlineEntity}
              setSelectedInlineEntity={setSelectedInlineEntity}
              entityList={dynamicEntityFilterList}
              isAnalysisReport={isAnalysisReport}
              selectedClientId={clientId}
              selectedInlineWCType={selectedInlineWCType}
              setSelectedInlineWCType={setSelectedInlineWCType}
              setSelectedInlineSentiment={setSelectedInlineSentiment}
              selectedInlineSentiment={selectedInlineSentiment}
              selectedInlinePlatform={selectedInlinePlatform}
              setSelectedInlinePlatform={setSelectedInlinePlatform}
              reportCategory={reportType.reportCategory}
              setSelectedInlineWCEntity={setSelectedInlineWCEntity}
              selectedInlineWCEntity={selectedInlineWCEntity}
              setSelectedInlineInfluencerEntity={
                setSelectedInlineInfluencerEntity
              }
              selectedInlineInfluencerEntity={selectedInlineInfluencerEntity}
              journalistList={journaList}
              selectedInlineZone={selectedInlineZone}
              setSelectedInlineZone={setSelectedInlineZone}
              selectedInlineGenre={selectedInlineGenre}
              setSelectedInlineGenre={setSelectedInlineGenre}
              selectedInlinePrintPublication={selectedInlinePublicationGenre}
              setSelectedInlinePrintPublication={
                setSelectedInlinePublicationGenre
              }
              publicationPrintInlineList={publicationGenrePrintInlineFilterList}
              publicationOnlineInlineList={
                publicationGenreOnlineInlineFilterList
              }
              selectedInlineDynamicFilter={selectedInlineDynamicFilter}
              setSelectedInlineDynamicFilter={setSelectedInlineDynamicFilter}
              dynamicFilterList={dynamicFilterList}
              selectedInlineDynamicFilterTwo={selectedInlineDynamicFilterTwo}
              setSelectedInlineDynamicFilterTwo={
                setSelectedInlineDynamicFilterTwo
              }
              dynamicFilterListTwo={dynamicFilterListTwo}
              selectedInlineGraphType={selectedInlineGraphType}
              spokespersonList={spokespersonList}
              setSelectedInlineSpokesperson={setSelectedInlineSpokesperson}
              selectedInlineSpokesperson={selectedInlineSpokesperson}
              keywordList={keywordList}
              sentimentList={sentimentList}
            />
          </div>
          <div className="chartActionRight">
            {(isEmbededWidget && isAnalysisReport) ||
              selectedInlineGraphType === TABLE ? null : (
              <Dropdown className="chartActionBtn chartMoreIcon" alignRight>
                <Dropdown.Toggle variant="default">
                  {<MoreIcon />}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {!isEmbededWidget && (
                    <>
                      <Dropdown.Header className="chartTypeHeading">
                        Graph Types
                      </Dropdown.Header>
                      {renderInlineGraphTypeSwitch()}
                    </>
                  )}
                  {showChartValueOption && (
                    <>
                      <Dropdown.Header className="chartValuesHeading">
                        Graph Values
                      </Dropdown.Header>
                      <Dropdown.Item className="diWithRadio numericItem">
                        <label
                          className="inputWrap"
                          onClick={() => setShowPercentage(false)}
                        >
                          Numeric
                          <input
                            type="radio"
                            key={showPercentage}
                            checked={!showPercentage}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </Dropdown.Item>
                      <Dropdown.Item className="diWithRadio percentageItem">
                        <label
                          className="inputWrap"
                          onClick={() => setShowPercentage(true)}
                        >
                          Percentage
                          <input
                            type="radio"
                            key={showPercentage}
                            checked={showPercentage}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            )}
            <Dropdown className="chartActionBtn chartDownloadIcon" alignRight>
              <div className="hasTooltip">
                <Dropdown.Toggle variant="default">
                  <DownloadBlueIcon />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {selectedInlineGraphType != TABLE && (
                    <Dropdown.Item onClick={() => downloadChart(chartTitle)}>
                      Download PNG
                    </Dropdown.Item>
                  )}
                  {/* <Dropdown.Item onClick={() => downloadCsv(chartTitle)}>
                    Download CSV
                  </Dropdown.Item> */}
                </Dropdown.Menu>
                <span className="tooltipWrap center">Download</span>
              </div>
            </Dropdown>
          </div>
        </div>
        {isLoading && <Loader />}
        {!twitterFeeds && !isLoading && !showError && (
          <WidgetSwitch
            key={selectedInlineGraphType}
            graph_type={selectedInlineGraphType}
            graphApiResponse={graphApiResponse}
            chartTitle={chartTitle}
            onEntityClick={onEntityClick}
            report_type={report_type}
            entityList={entityListByType}
            editionList={editionList}
            showPercentage={showPercentage}
            dataByReportType={dataByReportType}
            identifier={identifier}
            worldMapData={worldMapData}
            isAnalysisReport={isAnalysisReport}
            selectedDataType={selectedDataType}
            isEmbededWidget={isEmbededWidget}
            countryWiseFeeds={countryWiseFeeds}
            type={type}
            setGraphRef={setGraphRef}
            setGraphRefList={setGraphRefList}
          />
        )}
        {showPagination && (
          <WidgetPagination
            selectedIndex={datasetIndex}
            datasetLength={datasetLength}
            onSelectPage={updateDatasetIndex}
          />
          // <div className="dataPagination">
          //   <div className="btnContainer">
          //     <button onClick={() => updateDatasetIndex("prev")}>Prev</button>
          //     <button onClick={() => updateDatasetIndex("next")}>Next</button>
          //   </div>
          // </div>
        )}
        {!twitterFeeds && !isLoading && showError && (
          <h6
            style={{
              textAlign: "center",
              marginTop: "25%",
            }}
          >
            {chartTitle}: No data available.
          </h6>
        )}
      </div>
    </div>
  );
};

Widget.defaultProps = {
  renderAnalysisWidget: () => { },
  contributedWidgetFilter: {},
};
